'use client'
import TestamonialCardSlider from '@components/TestamonialCardSlider'

const TestamonialCardSliderWrapper = ({ testamonials = [], title, description, dictionary, lang }) => {

    return (
        <>
            {testamonials && testamonials.length > 0 && (
                <TestamonialCardSlider title={title} description={description} items={testamonials}  lang={lang} dictionary={dictionary} />
            )}
        </>
    );
};

export default TestamonialCardSliderWrapper;